import { useI18n } from "../i18n/LocaleContext";

export function AboutPage() {
  const { t } = useI18n();

  return (
    <section className="content-page narrow" aria-labelledby="about-title">
      <div className="content-page-heading">
        <p className="eyebrow">{t.pages.aboutEyebrow}</p>
        <h1 id="about-title">{t.pages.aboutTitle}</h1>
      </div>
      <div className="prose-panel">
        {t.pages.aboutBody.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
